import { render, staticRenderFns } from "./ckArea.vue?vue&type=template&id=70f44cb2&scoped=true"
import script from "./ckArea.vue?vue&type=script&lang=js"
export * from "./ckArea.vue?vue&type=script&lang=js"
import style0 from "./ckArea.vue?vue&type=style&index=0&id=70f44cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f44cb2",
  null
  
)

export default component.exports